"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QualtricsInjector = exports.qualtricsScriptElement = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var QUALTRICS_SCRIPT_ID = 'qualtrics-intercept';
var qualtricsScriptElement = function (zoneId, link) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = "(function(){var g=function(e,h,f,g){\n            this.get=function(a){for(var a=a+\"=\",c=document.cookie.split(\";\"),b=0,e=c.length;b<e;b++){for(var d=c[b];\" \"==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};\n            this.set=function(a,c){var b=\"\",b=new Date;b.setTime(b.getTime()+6048E5);b=\"; expires=\"+b.toGMTString();document.cookie=a+\"=\"+c+b+\"; path=/; \"};\n            this.check=function(){var a=this.get(f);if(a)a=a.split(\":\");else if(100!=e)\"v\"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(\":\"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case \"v\":return!1;case \"r\":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(\":\")),!c}return!0};\n            this.go=function(){if(this.check()){var a=document.createElement(\"script\");a.type=\"text/javascript\";a.src=g;document.body&&document.body.appendChild(a)}};\n            this.start=function(){var t=this;\"complete\"!==document.readyState?window.addEventListener?window.addEventListener(\"load\",function(){t.go()},!1):window.attachEvent&&window.attachEvent(\"onload\",function(){t.go()}):t.go()};};\n            try{(new g(100,\"r\",\"QSI_S_".concat(zoneId, "\",\"").concat(link, "\")).start()}catch(i){}})();");
    script.async = true;
    script.id = QUALTRICS_SCRIPT_ID;
    return script;
};
exports.qualtricsScriptElement = qualtricsScriptElement;
var QualtricsInjector = function (props) {
    var routePath = props.routePath, qualtricsZoneId = props.qualtricsZoneId, qualtricsLink = props.qualtricsLink, showSurvey = props.showSurvey, children = props.children;
    var pathLocation = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(function () {
        if (pathLocation.pathname === routePath && showSurvey) {
            var existingScript = document.getElementById(QUALTRICS_SCRIPT_ID);
            if (!existingScript) {
                document.body.appendChild((0, exports.qualtricsScriptElement)(qualtricsZoneId, qualtricsLink));
            }
        }
        return function () {
            var inlineScript = document.getElementById(QUALTRICS_SCRIPT_ID);
            if (inlineScript) {
                document.body.removeChild(inlineScript);
            }
            var externalScript = Array.from(document.querySelectorAll('script')).find(function (s) { return s.src === qualtricsLink; });
            if (externalScript) {
                document.body.removeChild(externalScript);
            }
        };
    }, [pathLocation.pathname, qualtricsZoneId, qualtricsLink, showSurvey]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.QualtricsInjector = QualtricsInjector;
exports.QualtricsInjector.displayName = 'QualtricsInjector';
//# sourceMappingURL=qualtricsInjector.js.map